import { BigNumber } from '@ethersproject/bignumber';
import { useEffect, useState } from 'react';
import { convertToUSD } from '@/common/currency';

export function useConvertUSD({ price, networkId }: { price: BigNumber; networkId: number }) {
  const [isLoading, setIsLoading] = useState(false);
  const [usdValue, setUsdValue] = useState<number>();

  useEffect(() => {
    async function convert() {
      setIsLoading(true);
      try {
        const value = await convertToUSD(networkId, price);
        setUsdValue(value);
      } finally {
        setIsLoading(false);
      }
    }
    convert();
  }, [price]);

  return { usdValue, isLoading };
}
